import me from "models/me";

export default (ldflags) => {
    return (_nextState, replace, callback) => {
        const { marketplaceAccessRedirectOnRetailerProfileExistsNu70887 } = ldflags;
        if (
            marketplaceAccessRedirectOnRetailerProfileExistsNu70887
                ? me.isGuestBuyer() && !(me.retailers.length > 0)
                : me.isGuestBuyer() && !me.buyer_form_submitted
        ) {
            replace({
                pathname: "/retailer-profile",
                query: {
                    redirect: _nextState.location.pathname + (_nextState.location.search || ""),
                },
            });
        }
        callback();
    };
};
